import type { DashboardGroupTSP, ProjectStatusSP } from '@/types/dashboard';
import { apiService } from './api';

class StatusService
{
  /**
   * Save Project
   */
  async SaveDashboard(requestConfig: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(
        `/Status/SaveDashboardGroupStatus`,
        requestConfig,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /**
   * Get Project Status
   */
  async GetProjectStatus(projectId: string): Promise<ProjectStatusSP>
  {
    try
    {
      const response = await apiService.get<ProjectStatusSP>(
        `/Status/GetProjectStatus?projectId=${projectId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /**
   * Get Project Status
   */
  async GetStatus(): Promise<ProjectStatusSP>
  {
    try
    {
      const response = await apiService.get<ProjectStatusSP>(`/Status/GetStatus`);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /**
   * Get Dashboard Group By Id
   */
  async GetDashboardGroupById(dashboardId: string): Promise<DashboardGroupTSP>
  {
    try
    {
      const response = await apiService.get<DashboardGroupTSP>(
        `/Status/GetDashboardGroupNameById?dashboardId=${dashboardId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /**
   * Save Project
   */
  async SaveProject(requestConfig: any): Promise<any>
  {
    try
    {
      const response = await apiService.post<any>(`/Status/SaveProjectStatus`, requestConfig);
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  /**
   * Get Dashboard Group Status
   */
  async GetDashboardGroupStatus(dashboardId: string): Promise<any>
  {
    try
    {
      const response = await apiService.get<any>(
        `/Status/GetDashboardGroupStatus?dashboardId=${dashboardId}`,
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }
}

export const statusService = new StatusService();
